import { render, staticRenderFns } from "./abroad-contact.vue?vue&type=template&id=ca4f39b8&scoped=true&"
import script from "./abroad-contact.vue?vue&type=script&lang=js&"
export * from "./abroad-contact.vue?vue&type=script&lang=js&"
import style0 from "./abroad-contact.vue?vue&type=style&index=0&id=ca4f39b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4f39b8",
  null
  
)

export default component.exports